import { DEFAULT_ARENA_LAYOUT, ARENA_OBSTACLES, type ArenaObstacle } from "@neon-arena/shared";

export type { ArenaObstacle };
export { ARENA_OBSTACLES };

// Thin wrapper kept for API compatibility with Game.ts.
// Physics is now purely kinematic inside VehicleController.
export class PhysicsWorld {
  obstacles = DEFAULT_ARENA_LAYOUT.obstacles;
  // eslint-disable-next-line @typescript-eslint/require-await
  async init(): Promise<void> { /* no-op */ }
  step(_dt: number): void { /* no-op */ }
}
